import dynamic from "next/dynamic";
import SquareShapeConfig from "./square-shape-config";
import SquareShapeAdvancedConfig from "./square-shape-advanced-config";
const SquareShapeComponent = dynamic(()=>import("./square-shape-component"));
export default {
    SquareShapeComponent,
    SquareShapeConfig,
    SquareShapeAdvancedConfig
};
